<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="notifications.length"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Notificações
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ notifications.length }} New
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Notifications -->
      <b-link
        v-for="notification in notifications"
        :key="notification.key"
        :href="notification.link"
        :target="notification.target ? '_blank' : '_self'"
        @click="setNotificationsReadByKey(notification.key)"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :variant="resolveVarianteNotification(notification.type)"
            >
              <feather-icon :icon="resolveIconNotification(notification.type)" />
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.titulo }}
            </span>

          </p>
          <small class="notification-text">{{ notification.descricao }}</small> <br>
          <span
            class="d-flex justify-content-end"
            style="padding-top: 10px;padding-bottom: 0"
          >
            <small
              class="text-black"
              style="font-size: 0.7rem"
            >{{ notification.date | timestampToDate }}</small>
          </span>

        </b-media>
      </b-link>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        @click="setNotificationsRead"
      >
        Ver todas as notificações
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import {
  onValue, ref, db, update,
} from '@/libs/firebase'
import store from '@/store'
import { timestampToDate } from '@core/utils/utils'
import api from '@axios'
import Swal from 'sweetalert2'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
  },
  directives: {
    Ripple,
  },
  filters: {
    timestampToDate,
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      notificationsAll: [],
    }
  },
  computed: {
    notifications: {
      get() {
        return store.getters['storeNotifications/getNotificationsUser']
      },
      set(value) {
        store.commit('storeNotifications/setNotificationsUser', value)
      },
    },
    userData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  created() {
    store.commit('storeNotifications/setNotificationUser', this.userData.id)
    const onValueChange = ref(db, store.getters['storeNotifications/getRefNotificationUser'])
    onValue(onValueChange, snapshot => this.handleMessages(snapshot.val()))
  },
  destroyed() {
    store.dispatch('storeNotifications/resertStoreNotifications')
  },
  methods: {
    setNotificationsReadByKey(key) {
      store.dispatch('storeNotifications/setNotificationsReadByKey', {
        key,
        id_user: this.userData.id,
      })
    },
    setNotificationsRead(redirect = true) {
      if (redirect) {
        this.$router.push({ name: 'all-notifications' })
      }
      const u = {}
      u[this.userData.id] = false
      update(ref(db, '/notification_not_read'), u)
      store.dispatch('storeNotifications/setNotReadNotifications', this.userData.id)
    },
    compare(a, b) {
      if (a.date > b.date) {
        return -1
      }
      if (a.date < b.date) {
        return 1
      }
      return 0
    },
    async setMessages(data) {
      data.pop()
      const messegesFilter = data.filter(item => item.notification_not_read === true)
      const clearLocalStorage = messegesFilter.filter(m => m.evento && m.evento === 'pagamento.paid')
      if (clearLocalStorage.length > 0) {
        this.setNotificationsRead(false)
        // localStorage.clear()
        this.$router.push({ name: 'auth-login' })
      }

      const userBloqueiado = messegesFilter.filter(m => m.evento && m.evento === 'user.blocked')
      if (userBloqueiado.length > 0) {
        this.setNotificationsReadByKey(userBloqueiado[0].key)
        // localStorage.clear()
        Swal.fire(
          'Usuário Bloqueado',
          'Entre em contato com o suporte',
          'error',
        )
          .finally(() => {
            this.$router.push({ name: 'auth-login' })
          })
      }

      const userAtivo = messegesFilter.filter(m => m.evento && m.evento === 'user.ativo')
      if (userAtivo.length > 0) {
        this.setNotificationsRead(false)
        await api.get(`/find?uuid=${this.userData.uuid}`)
          .then(response => {
            const {
              abillity, planos, adresses, chats, integrations, main_address, pagamento_cobranca, cursos, ...dataUsuario
            } = response.data
            localStorage.setItem('userData', JSON.stringify({
              ...dataUsuario,
              ability: abillity,
              address: main_address || [],
            }))
            this.$store.commit('User/setUser', {
              ...dataUsuario,
              ability: abillity,
              address: main_address || null,
            })
          })
      }

      // eslint-disable-next-line no-param-reassign
      store.commit('storeNotifications/setAllNotifications', data)
      store.commit('storeNotifications/setNotificationsUser', messegesFilter)
    },
    handleMessages(data) {
      const toMessages = []
      if (data === null || data === undefined) return
      Object.keys(data).map(key => {
        toMessages.push(data[key])
      })
      toMessages.sort(this.compare)
      this.setMessages(toMessages)
    },
    resolveIconNotification(type) {
      switch (type) {
        case 'primary':
          return 'BellIcon'
        case 'success':
          return 'CheckCircleIcon'
        case 'danger':
          return 'XCircleIcon'
        case 'warning':
          return 'AlertTriangleIcon'
        case 'info':
          return 'InfoIcon'
        default:
          return 'BellIcon'
      }
    },
    resolveVarianteNotification(type) {
      switch (type) {
        case 'primary':
          return 'primary'
        case 'success':
          return 'success'
        case 'danger':
          return 'danger'
        case 'warning':
          return 'warning'
        case 'info':
          return 'info'
        default:
          return 'primary'
      }
    },
  },
}
</script>

<style>

</style>
